import { render, staticRenderFns } from "./RecipeSection.vue?vue&type=template&id=0b74f260&scoped=true&"
import script from "./RecipeSection.vue?vue&type=script&lang=js&"
export * from "./RecipeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74f260",
  null
  
)

export default component.exports